import { Modal } from '@televet/kibble-ui/build/components/Modal';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { ModalBody } from '@televet/kibble-ui/build/components/Modal';
import { ModalCloseButton } from '@televet/kibble-ui/build/components/Modal';
import { ModalHeader } from '@televet/kibble-ui/build/components/Modal';
import { ModalFooterButtons } from '@televet/kibble-ui/build/components/Modal';
import React from 'react';
import withLazyModal from '../LazyModal/withLazyModal';

type DeleteTemplateModalProps = {
  onClose: () => void;
  isOpen: boolean;
  templateId: string | undefined;
  templateName: string;
  handleDeleteTemplate: (id: string) => void;
};

const DeleteTemplateModal = ({
  onClose,
  isOpen,
  templateId,
  templateName,
  handleDeleteTemplate,
}: DeleteTemplateModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>Delete Template</ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={5}>
        <Text as="p">
          Are you sure you want to delete the template &quot;<Text fontWeight="bold">{templateName}</Text>&quot;
        </Text>
      </ModalBody>
      <ModalFooterButtons
        submitText="Delete Template"
        isDestructive
        onSubmit={(): void => handleDeleteTemplate(templateId as string)}
      />
    </Modal>
  );
};

export default withLazyModal(DeleteTemplateModal);
